export const useHMSRecorder = () => ({
  recorderToken: null,
});
